module.exports = __webpack_public_path__ + "static/media/bottom_shape_5_mob.bba91d18.svg";